import React, { useEffect, useState } from 'react';

interface Day {
    id: number;
    name: string;
}

interface SettingsDayPickerProps {
    value: number[];
    onChange: (dayIds: number[]) => void;
}

const DAYS: Day[] = [
    { id: 1, name: 'Esmaspäev' },
    { id: 2, name: 'Teisipäev' },
    { id: 3, name: 'Kolmapäev' },
    { id: 4, name: 'Neljapäev' },
    { id: 5, name: 'Reede' },
    { id: 6, name: 'Laupäev' },
    { id: 7, name: 'Pühapäev' }
];

const SettingsDayPicker: React.FC<SettingsDayPickerProps> = ({ value, onChange }) => {
    const [selectedDays, setSelectedDays] = useState<number[]>(value);

    useEffect(() => {
        setSelectedDays(value);
    }, [value]);

    const handleSelectChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
        const selectedOptions = Array.from(event.target.selectedOptions).map(option => parseInt(option.value));
        const newSelected = [...new Set([...selectedDays, ...selectedOptions])];

        setSelectedDays(newSelected);
        onChange(newSelected);
    };

    const handleRemoveDay = (dayId: number) => {
        const newSelected = selectedDays.filter(id => id !== dayId);

        setSelectedDays(newSelected);
        onChange(newSelected);
    };

    const getDayName = (id: number) => {
        const day = DAYS.find(d => d.id === id);
        return day ? day.name : 'Tundmatu';
    };

    return (
        <div className="w-full">
            {selectedDays.length > 0 && (
                <div className="selected-countries mb-2">
                    {selectedDays.map(id => (
                        <span key={id} className="selected-country">
                            {getDayName(id)}
                            <button
                                type="button"
                                onClick={() => handleRemoveDay(id)}
                                className="remove-country"
                            >
                                ✕
                            </button>
                        </span>
                    ))}
                </div>
            )}
            <select
                multiple
                value={selectedDays.map(String)}
                onChange={handleSelectChange}
                className="text w-full p-2 border rounded"
            >
                {DAYS.map(day => (
                    <option key={day.id} value={day.id}>
                        {day.name}
                    </option>
                ))}
            </select>
        </div>
    );
};

export default SettingsDayPicker;